import React, { Component } from "react";
import * as Cookies from "es-cookie";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { Row, Col, Container, Form } from 'react-bootstrap'


const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
        state_id
        city_id
        district_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
        exam_subjects{
                subject_id
              }
      }
      globalBranches {
        id
        branch_name
        state_id
        city_id
        district_id
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
         states {
      state_id
      state_name
    }
    districts {
      id
      district_name
      state_id
    }
    cities {
      id
      district_id
      region_id
      city_name
      timestamp
    }
    }
  }
`;


class SingleSelectionDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStateValue: "",
            selectedDistrictValue: "",
            selectedCityValue: "",

            selectedBranchValue: "",
            selectedExamValue: "",
            selectedClassValue: "",
            selectedSectionValue: "",

            getDistrictArr: [],
            getCitiesArr: [],
            error: {},
            getBranchArr: [],
            getExamArr: [],
            getClassArr: [],
            getSectionArr: [],
        };
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        const { globals } = this.props;
        if (!globals || !globals.globals) return;

        const { districts = [], cities = [], b_e_c_s_data = [], exams = [], educationalClasses = [], globalSections = [], globalBranches = [] } = globals.globals;

        if (name === "selectedStateValue") {
            const filteredDistricts = districts.filter((d) => +d.state_id === +value);
            this.setState(
                {
                    selectedStateValue: value,
                    selectedDistrictValue: "",
                    selectedCityValue: "",
                    getDistrictArr: filteredDistricts.map((item) => ({ value: item.id, label: item.district_name })),
                    getCitiesArr: [],
                    errors: {},
                    getBranchArr: [],
                    getExamArr: [],
                    getClassArr: [],
                    getSectionArr: [],
                    selectedBranchValue: "",
                    selectedExamValue: "",
                    selectedClassValue: "",
                    selectedSectionValue: "",
                },
                this.sendData
            );

        } else if (name === "selectedDistrictValue") {
            const filteredCities = cities.filter((c) => +c.district_id === +value);

            this.setState(
                {
                    selectedDistrictValue: value,
                    selectedCityValue: "",
                    getCitiesArr: filteredCities.map((item) => ({ value: item.id, label: item.city_name })),
                    error: {},
                    getBranchArr: [],
                    getExamArr: [],
                    getClassArr: [],
                    getSectionArr: [],
                    selectedBranchValue: "",
                    selectedExamValue: "",
                    selectedClassValue: "",
                    selectedSectionValue: "",
                },
                this.sendData
            );
        } else if (name === "selectedCityValue") {
            const { selectedStateValue, selectedDistrictValue } = this.state;

            const getBranchArr = globalBranches
                .filter(
                    (item) =>
                        +item.state_id === +selectedStateValue &&
                        +item.district_id === +selectedDistrictValue &&
                        +item.city_id === +value
                )
                .map((b) => ({ value: b.id, label: b.branch_name }));

            this.setState(
                {
                    selectedCityValue: value,
                    getBranchArr: getBranchArr,
                    selectedBranchValue: "",
                    selectedExamValue: "",
                    selectedClassValue: "",
                    selectedSectionValue: "",
                },
                this.sendData
            );
        } else if (name === "selectedBranchValue") {
            const branchId = +value;
            const uniqueExamIds = [
                ...new Set(
                    (b_e_c_s_data || [])
                        .filter((item) => +item.branch_id === branchId)
                        .map((item) => Number(item.exam_id))
                ),
            ];

            const getExamArr = uniqueExamIds
                .map((id) => exams.find((e) => +e.id === +id))
                .filter(Boolean)
                .map((e) => ({
                    value: e.id,
                    label: e.exam,
                }));

            this.setState(
                {
                    selectedBranchValue: branchId,
                    selectedExamValue: "",
                    selectedClassValue: "",
                    selectedSectionValue: "",
                    getExamArr: getExamArr,
                },
                this.sendData
            );
        } else if (name === "selectedExamValue") {
            const branchId = +this.state.selectedBranchValue;
            const examId = +value;

            const uniqueClassIds = [
                ...new Set(
                    (b_e_c_s_data || [])
                        .filter(
                            (item) => +item.branch_id === branchId && +item.exam_id === examId
                        )
                        .map((item) => Number(item.class_id))
                ),
            ];

            const getClassArr = uniqueClassIds
                .map((id) => educationalClasses.find((c) => +c.id === +id))
                .filter(Boolean)
                .map((cls) => ({ value: cls.id, label: cls.class }));


            this.setState(
                {
                    selectedExamValue: examId,
                    selectedClassValue: "",
                    selectedSectionValue: "",
                    getClassArr: getClassArr,
                },
                this.sendData
            );
        } else if (name === "selectedClassValue") {
            const branchId = +this.state.selectedBranchValue;
            const examId = +this.state.selectedExamValue;
            const classId = +value;

            const uniqueSectionIds = [
                ...new Set(
                    (b_e_c_s_data || [])
                        .filter(
                            (item) => +item.branch_id === branchId && +item.exam_id === examId && +item.class_id === classId
                        )
                        .map((item) => Number(item.section_id))
                ),
            ];

            let getSectionArr = [];

            uniqueSectionIds.forEach((val) => {
                let sec = globalSections.find((s) => +s.id === +val);
                if (sec) {
                    getSectionArr.push({
                        value: sec.id,
                        label: sec.section_name,
                    });
                }
            });

            this.setState(
                {
                    selectedClassValue: classId,
                    selectedSectionValue: "",
                    getSectionArr: getSectionArr,
                },
                this.sendData
            );

        } else {
            this.setState({ [name]: value }, this.sendData);
        }
    };


    // 👈 Send data to parent
    sendData = () => {
        if (this.props.onSelect) {
            this.props.onSelect(this.state);
        }
    };

    render() {
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        const { selectedStateValue, selectedDistrictValue, selectedCityValue, errors = {}, getDistrictArr = [], getCitiesArr = [], getExamArr = [], getClassArr = [],
            selectedBranchValue, getSectionArr = [],
            selectedExamValue,
            selectedClassValue,
            selectedSectionValue, getBranchArr = [] } = this.state;

        const { states = [] } = globals.globals || {};

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        const { showBranch } = this.props;
        console.log('showBranch', showBranch);

        const filterSelections = [
            { rowId: 1, name: "selectedStateValue", placeholder: "Select State", error: errors.selectedStateValue, value: selectedStateValue, options: states.map((item) => ({ label: item.state_name, value: item.state_id })), show: true, },
            { rowId: 2, name: "selectedDistrictValue", placeholder: "Select District", error: errors.selectedDistrictValue, value: selectedDistrictValue, options: getDistrictArr, show: true, },
            { rowId: 3, name: "selectedCityValue", placeholder: "Select City", error: errors.selectedCityValue, value: selectedCityValue, options: getCitiesArr, show: true, },
            { rowId: 4, name: "selectedBranchValue", placeholder: "Select Branch", error: errors.selectedBranchValue, value: selectedBranchValue, options: getBranchArr, show: showBranch },
            { rowId: 5, name: "selectedExamValue", placeholder: "Select Exam", error: errors.selectedExamValue, value: selectedExamValue, options: getExamArr, show: true, },
            { rowId: 6, name: "selectedClassValue", placeholder: "Select Class", error: errors.selectedClassValue, value: selectedClassValue, options: getClassArr, show: true, },
            { rowId: 7, name: "selectedSectionValue", placeholder: "Select Section", error: errors.selectedSectionValue, value: selectedSectionValue, options: getSectionArr, show: true, },
        ];

        return (
            <div>
                <Container fluid>
                    {loading1 ? (
                        <Container>
                            <Row className="my-3">
                                <Col>
                                    <div className="spinner-border text-primary text-center loading-img-center"></div>
                                </Col>
                            </Row>
                        </Container>
                    ) : (
                        <Row>
                            {
                                filterSelections.filter((item)=> item.show === true).map((field) => (
                                    <Col sm={3} className="mt-2">
                                        <Form.Control
                                            as="select"
                                            name={field.name}
                                            value={field.value}
                                            onChange={this.handleInputChange}
                                        >
                                            <option value="">--{field.placeholder}--</option>
                                            {field.options.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <div className="text-danger">{field.error}</div>
                                    </Col>
                                ))
                            }
                        </Row>
                    )}
                </Container>
            </div>
        );
    }
}

export default withRouter(
    compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        institution_id: parseInt(Cookies.get("institutionid"))
                    }
                }), name: "globals"
            }),
    )
        (SingleSelectionDropdown));